import { FC, Fragment } from "react";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { NumberInput } from "../core/NumberField";
import { useStyles } from "../../useStyles";
import { Switch } from "../core/Switch";
import { Grid, InputLabel } from "@material-ui/core";

import { MiscellaneousIcon } from "../core/icons/Icons";
import { BoxedInputWithIconAndOptionalSwitch } from "../core/BoxedInputWithIconAndOptionalSwitch";
import { LabledTextField } from "../core/LabledTextField";

export const ElectricMiscellaneousForm: FC = () => {
    const classes = useStyles();
    const { values, getFieldProps, setValues } =
        useFormModel<ChangeNames.NEW_CONNECTION_ELECTRIC_MISCELLANEOUS>();
    return (
        <Fragment>
            <BoxedInputWithIconAndOptionalSwitch
                icon={<MiscellaneousIcon />}
                content={
                    <p className={classes.label} style={{ marginBottom: 8 }}>
                        Sonstige Verbraucher
                    </p>
                }
                useSwitch={
                    <Switch
                        checked={values.newConnectionElectricMiscellaneous.value.installed}
                        {...getFieldProps("newConnectionElectricMiscellaneous.value.installed")}
                        onChange={(e, checked) =>
                            setValues((values) => {
                                values.newConnectionElectricMiscellaneous.value.installed = checked;
                                values.newConnectionElectricMiscellaneous.value.description =
                                    checked ? "" : null;
                                values.newConnectionElectricMiscellaneous.value.demand.amount =
                                    checked ? 0 : null;
                            })
                        }
                    />
                }
                detailCondition={values.newConnectionElectricMiscellaneous.value.installed}
                detail={
                    <Grid
                        container
                        spacing={4}
                        alignItems="flex-end"
                        style={{ paddingBottom: "12px" }}
                    >
                        <Grid item xs={12} md={8}>
                            <LabledTextField
                                label="Bezeichnung"
                                variant="outlined"
                                style={{ width: "100%" }}
                                placeholder="Motoren, Schweißgeräte, etc."
                                InputProps={{
                                    className: classes.textField,
                                    style: { width: "100%" },
                                    inputProps: {
                                        style: { fontFamily: "innogyWeb" },
                                    },
                                }}
                                inputProps={{
                                    maxLength: 100,
                                }}
                                value={values.newConnectionElectricMiscellaneous.value.description}
                                onChange={(v) =>
                                    setValues((values) => {
                                        values.newConnectionElectricMiscellaneous.value.description =
                                            v.target.value;
                                    })
                                }
                                error={!!values.newConnectionElectricMiscellaneous.error}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputLabel
                                className={classes.labledTextfieldLabel}
                                error={!!values.newConnectionElectricMiscellaneous.error}
                            >
                                Summe der Leistung
                            </InputLabel>
                            <NumberInput
                                className={classes.textField}
                                style={{ width: "100%" }}
                                fixedDecimalScale={false}
                                allowLeadingZeros={false}
                                decimalScale={
                                    values.newConnectionElectricMiscellaneous.value.demand.precision
                                }
                                isNumericString={false}
                                allowNegative={false}
                                thousandSeparator="."
                                decimalSeparator=","
                                adornment={
                                    values.newConnectionElectricMiscellaneous.value.demand.unit
                                }
                                value={
                                    values.newConnectionElectricMiscellaneous.value.demand.amount ||
                                    ""
                                }
                                placeholder="0"
                                onValueChange={(v) =>
                                    setValues((values) => {
                                        values.newConnectionElectricMiscellaneous.value.demand.amount =
                                            v.floatValue || null;
                                    })
                                }
                                error={!!values.newConnectionElectricMiscellaneous.error}
                            />
                        </Grid>
                    </Grid>
                }
            />
        </Fragment>
    );
};
